/**
 * Client entry: mount the app over the boot placeholder in #app.
 */
import { render } from 'preact';
// ⛔ T1749 M2 — THE STYLESHEET ORDER IS THE CASCADE AND IT IS LOAD-BEARING.
// Five sheets, in exactly this order, on BOTH tools:
//   1. @ecmb/ui/styles/tokens.css  the 43 shared names (DESIGN.md §3), declared once
//   2. ./styles/tokens.css         this surface's exceptions only (never a shared name)
//   3. @ecmb/ui/styles/base.css    ADR4-D3's one base layer; consumes the tokens
//   4. @ecmb/ui/styles/components.css  the rules both tools share, byte for byte
//   5. ./styles/app.css            this surface's own rules; overrides everything above
// A component rule moved into (4) therefore has LOWER precedence than anything left in
// (5), which is why M2's move was restricted to rules no later app.css rule overrides.
// `style-contract.spec.ts` asserts this exact list, on both tools.
import '@ecmb/ui/styles/tokens.css';
import './styles/tokens.css';
import '@ecmb/ui/styles/base.css';
import '@ecmb/ui/styles/components.css';
import './styles/app.css';
import { App } from './app.js';

const root = document.getElementById('app');
if (root) {
  root.replaceChildren();
  render(<App />, root);
}
